// extracted by mini-css-extract-plugin
export default {"productGrid":"oca-z","centerLink":"pca-z","productSection":"qca-z","item":"rca-z","ctaButton":"sca-z"};